module.exports = __webpack_public_path__ + "static/img/whyItem_04.7ffc7718.png";